import { Component, OnInit, OnChanges, SimpleChanges, SimpleChange, Input, Output, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, EventEmitter, ViewEncapsulation, ElementRef, Renderer2  } from '@angular/core';
import { ModalComponent } from 'lib/modal/modal.component';
import { KeyValue } from '@angular/common';
import { Keys } from 'lib/common';
import { COMMA, ENTER } from '@angular/cdk/keycodes';

////  ['./criteria.component.scss', '../user-privileges.component.scss', '../../filters-tabs/search-criteria/search-criteria.component.scss',
///'../../styles/input.css', '../../styles/buttons.css', '../../styles/mat-themes.scss']
@Component({
  selector: 'app-image-popup-modals',
  templateUrl: './image-popup-modals.component.html',
  styleUrls: ['./image-popup-modals.component.scss']
})
export class ImagePopupModalsComponent implements OnInit {

  imageUrl: any = ""; //"..//Webviewer/assets/images/Help/ExplorOptions/Custom Reports/VoiceQualityTestHeader.jpg";
  @Input() imageDetails: any;
  @Input() modalWidth: number;
  @Input() modalHeight: number;
  @ViewChild('childModal', { static: false }) childModal: ModalComponent;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();

  constructor(private cd: ChangeDetectorRef, private renderer: Renderer2, private el: ElementRef) { }

  ngOnInit() {
    debugger;
   // this.loadInitSelection();
  }

  ngOnChanges(changes: SimpleChanges) {
    debugger;
    //recall on pinDetails changed from original config screen - IMP
    this.loadInitSelection();
  }

  open() {
    debugger;
    setTimeout(() => {
      this.childModal.show();
    }, 500);
    //this.childModal.show();
    this.cd.markForCheck();
  }

  loadInitSelection() {
    debugger;
    if (this.imageDetails !== undefined) {
      this.imageUrl = "../" + this.imageDetails;
      this.increaseOverlayHeight();
    }
  }

  onCloseModal() {
    //console.log(this.modelPinColor) 
    let pinDetails = "test"; 
    this.closeModal.emit(pinDetails);
  }

  onMouseDown(event: MouseEvent) {
    // Prevent default behavior of mouse down event
    event.preventDefault();
  }

  increaseOverlayHeight() {
    // Select the overlay div by its class or ID
    const overlayDiv = this.el.nativeElement.querySelector('.ui-modal-overlay');

    // Check if the overlay div exists
    if (overlayDiv) {
      // Increase the height of the overlay div
      this.renderer.setStyle(overlayDiv, 'height', '1500px'); // Example height
    }
  }

}
